// firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from "firebase/analytics";


const firebaseConfig = {
  apiKey: "AIzaSyAyhhfyUHtWmwIBqxzN_7m6smpd2xi7Y4c",
  authDomain: "portfolio-christian-lira.firebaseapp.com",
  projectId: "portfolio-christian-lira",
  storageBucket: "portfolio-christian-lira.firebasestorage.app",
  messagingSenderId: "658298256548",
  appId: "1:658298256548:web:c01277ebc5300ab4beba31"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Firestore
export const db = getFirestore(app);

// Cloud Functions (used with httpsCallable)
export const functions = getFunctions(app, 'us-central1');

// Analytics Config
const analytics = getAnalytics(app);




